import {OrderProcessStateType} from '@web/core/constants'

export * from './course'

export * from './fds'

export * from './finished'

export const ErrorMessage = {
    OrderApiFail: '주문이 원활하지 않습니다. 다시 시도해주시기 바랍니다.',
} as const

/**
 * TODO shard 적용후 core 에 업데이트 합니다.
 **/
export type OrderProcessStatusType = OrderProcessStateType
